import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSolverMomentSizeM from './IconSolverMoment_size_m';

const props: CreateIconArguments = {
  l: IconSolverMomentSizeM,
  m: IconSolverMomentSizeM,
  s: IconSolverMomentSizeM,
  xs: IconSolverMomentSizeM,
  name: 'IconSolverMoment',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
